export const SERIVCEBOOK_MODULE_NAMESPACE = 'serviceBook'
export const SERVICEBOOK_GET_SERVICEBOOKS = 'SERVICEBOOK_GET_SERVICEBOOKS'
export const SERVICEBOOK_SET_SERVICEBOOKS = 'SERVICEBOOK_SET_SERVICEBOOKS'
export const SERVICEBOOK_SET_ISLOADING = 'SERVICEBOOK_SET_ISLOADING'
export const SERVICEBOOK_SET_SEARCH_PARAMS = 'SERVICEBOOK_SET_SEARCH_PARAMS'
export const SERVICEBOOK_SET_COUNT = 'SERVICEBOOK_SET_COUNT'
export const SERVICEBOOK_GET_SERVICEBOOK = 'SERVICEBOOK_GET_SERVICEBOOK'
export const SERVICEBOOK_SET_SERVICEBOOK = 'SERVICEBOOK_SET_SERVICEBOOK'
export const SERVICEBOOK_SET_PATCH = 'SERVICEBOOK_SET_PATCH'
export const SERVICEBOOK_INIT_PATCH = 'SERVICEBOOK_INIT_PATCH'
export const SERVICEBOOK_PATCH_SERVICEBOOK = 'SERVICEBOOK_PATCH_SERVICEBOOK'




// WEBPACK FOOTER //
// ./src/store/service-book/service-book-types.store.ts